module.exports = __webpack_public_path__ + "static/media/wallet.00403f3a.svg";